export const getDaysDuration = (startDate: Date, endDate: Date): number => {
  const diffTime = Math.abs(startDate.valueOf() - endDate.valueOf());
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24)) + 1;
};
